// extracted by mini-css-extract-plugin
export default {"empty":"Hand_empty__u2y14","handContainer":"Hand_handContainer__T2KhL","winner":"Hand_winner__ZZTpL"};